:host {
  @apply block;
}

::slotted([slot=social-media-items]) {
  @apply bg-no-repeat text-grey scale-100 sm:h-[35px] sm:w-[35px] w-[26px] h-[26px] md:ml-[30px] md:mr-0 md:mb-0 mx-[12px] mb-[15px] flex items-center overflow-visible;
  transition: color 0.25s linear, transform 0.25s linear;
}

::slotted([slot=social-media-items]:hover) {
  transform: scaleX(1.2) scaleY(1.2)
}

::slotted([slot=footer-links]) {
  @apply text-grey-dark md:text-footer-desktop text-footer-mobile mr-[20px];
}
